var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 395,
    viewBox: "0 0 359 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2207 272.593C51.7147 189.626 96.7627 143.861 174.869 142.95C252.974 143.861 298.022 189.626 330.517 272.593C345.481 310.801 341.39 329.8 309.658 336.634C277.943 343.466 226.406 346.312 174.869 346.312C123.332 346.312 71.7957 343.466 40.0797 336.634C8.34872 329.8 4.25672 310.801 19.2207 272.593Z",
    fill: "#5D689E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2207 272.593C49.7867 194.548 91.4657 149.427 161.316 143.589C231.337 149.534 273.088 196.286 303.696 277.237C316.252 310.445 315.388 329.642 296.04 339.143C264.273 344.169 219.572 346.311 174.868 346.311C123.331 346.311 71.7947 343.465 40.0787 336.633C8.34774 329.799 4.25675 310.801 19.2207 272.593Z",
    fill: "#7986BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.122 332.505C158.467 283.132 118.393 165.5 72.5059 137.747C138.924 20.4761 241.525 68.0101 277.23 137.747C231.343 165.5 199.777 283.132 179.122 332.505Z",
    fill: "#323E66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.868 192.499C106.7 188.078 88.6982 52.8433 174.868 52.8433C261.038 52.8433 243.036 188.078 174.868 192.499Z",
    fill: "#FDB0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.947 191.558C107.375 179.187 92.5468 60.01 167.947 53.166C243.348 60.011 228.519 179.187 167.947 191.558Z",
    fill: "#FFCEC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.326 94.7443C125.463 71.2743 143.062 52.8433 174.868 52.8433C206.674 52.8433 224.273 71.2743 230.41 94.7443C214.827 102.17 195.633 106.555 174.868 106.555C154.103 106.555 134.909 102.169 119.326 94.7443Z",
    fill: "#FF6161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5059 137.747C134.946 66.0191 214.792 66.0191 277.231 137.747C249.162 -31.5159 100.574 -31.5159 72.5059 137.747Z",
    fill: "#909CD1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.869 83.9513C210.44 83.9513 246.012 101.883 277.231 137.747C263.197 53.1163 219.033 10.8003 174.869 10.8003V83.9513Z",
    fill: "#7986BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.716 228.246H81.0206C78.2111 228.246 75.9336 230.524 75.9336 233.333V360.24C75.9336 363.05 78.2111 365.327 81.0206 365.327H268.716C271.525 365.327 273.803 363.05 273.803 360.24V233.333C273.803 230.524 271.525 228.246 268.716 228.246Z",
    fill: "#2DCFFC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M253.655 228.246H81.0206C78.2111 228.246 75.9336 230.524 75.9336 233.333V360.24C75.9336 363.05 78.2111 365.327 81.0206 365.327H253.655C256.464 365.327 258.742 363.05 258.742 360.24V233.333C258.742 230.524 256.464 228.246 253.655 228.246Z",
    fill: "#66DEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStalking);
export default __webpack_public_path__ + "static/media/stalking.0f941eac6cf541e602eba3252ad681f0.svg";
export { ForwardRef as ReactComponent };